import { Skeleton } from '@mui/material';
import { getInitials } from '@tempo-io/string-util';
import { Avatar, AvatarFallback, AvatarImage } from '@tempo-io/sui-avatar';
import { OverflowTooltip } from '@/components/ui/OverflowTooltip';
import {
  useIsUserMissing,
  useRegisterVisibleUserId,
  useVisibleUser,
} from '../context/VisibleUsersContext';
import { CellTextSkeleton } from './withSkeleton';

export const UserCell = ({ value }: { value?: string }) => {
  useRegisterVisibleUserId(value);
  const user = useVisibleUser(value);
  const isMissing = useIsUserMissing(value);

  if (value && !user) {
    if (isMissing) return null;
    return (
      <div className="flex items-center gap-2 min-w-0">
        <Skeleton variant="circular" width={20} height={20} />
        <CellTextSkeleton />
      </div>
    );
  }

  if (!user) return null;

  const displayName = user.name || user.email || '';

  return (
    <div className="flex items-center gap-2 min-w-0">
      <Avatar className="size-5">
        <AvatarImage src={user.pictureUrl} alt={displayName} />
        <AvatarFallback>{getInitials(displayName)}</AvatarFallback>
      </Avatar>
      <OverflowTooltip>{displayName}</OverflowTooltip>
    </div>
  );
};
